import { render, staticRenderFns } from "./SVGSearch.vue?vue&type=template&id=135f2d34&"
import script from "./SVGSearch.vue?vue&type=script&lang=js&"
export * from "./SVGSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports